import * as React from 'react'

type TextAreaProps = Partial<{
  className: string
  handleTextChange: (text: string) => void
  name: string
  placeholder: string
  text: string
  tw?: boolean
}> &
  Pick<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'onKeyDown' | 'onPaste'>

const twstyles = {
  main: 'placeholder:text-charcoal placeholder:font-opensans placeholder:text-xs placeholder:font-stretch-normal placeholder:not-italic placeholder:font-normal placeholder:tracking-normal focus:text-placeholder focus:font-opensans focus:text-xs focus:font-stretch-normal focus:not-italic focus:font-normal focus:tracking-normal disabled:cursor-not-allowed disabled:opacity-50 bg-[rgba(48,_55,_65,_0.04)] border border-charcoal-gray6 h-[144px] outline-[0] py-[6px] px-[11px] resize-none w-full',
}

const TextArea = ({ className, handleTextChange, text, ...props }: TextAreaProps) => (
  <textarea
    {...props}
    className={`${twstyles.main} ${className ?? ''}`}
    onChange={(event) => handleTextChange?.(event.target.value)}
    value={text}
  />
)

export default TextArea
